import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './EbsCustomAlert.module.scss';

export function EbsCustomAlert({
  className,
  content,
  isLarge,
  isLargeRadius,
  isSmallFont,
}: {
  className?: string;
  content: ReactNode;
  isLarge?: boolean;
  isLargeRadius?: boolean;
  isSmallFont?: boolean;
}) {
  return (
    <div
      className={classNames(
        styles.container,
        { [styles.large]: isLarge, [styles.largeRadius]: isLargeRadius, [styles.smallFont]: isSmallFont },
        className,
      )}
    >
      {content}
    </div>
  );
}
